import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function MTPPublicInvestmentPlan({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightInvestmentProjects, setFilterHeight] = useState(688);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_investmentprojects]))").then(async (reply) => {
          const InvestmentProjectsNumberOfFilterRows = reply*27+40;
          console.log('InvestmentProjectsNumberOfFilterRows/Number of rows: ', InvestmentProjectsNumberOfFilterRows);
          setFilterHeight(InvestmentProjectsNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
            {/* <QlikObject
              className="page-title"
              id="ANJWBAj"
              height="35px"
              showLoader={false}
            /> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="2708863e-92f8-468a-a7f7-e7da08597902"
              height="30px"
              showLoader={false}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">

              <div className="row justify-content-left">
                {/* KPIs Row */}

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: no of total streams */}
                      <QlikCard
                        id="cee5b206-c4c8-4cdf-a79c-7907c9964cd1"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: no of total subsectors */}
                      <QlikCard
                        id="6f0d44d9-e7be-472e-bf86-e1d19e696100"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: total needs amount */}
                      <QlikCard
                        id="ddfe88b3-f4e3-4698-93d0-8bf90baf157b"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-3">
                      {/* KPI: funding cap amount */}
                      <QlikCard
                        id="eqHhJr"
                        height="90px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                      />
                    </div>

              </div>

              <div className="row justify-content-left">
                {/* Charts Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 1*/}
                      <QlikCard
                        id="xsJT"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
{/*                   <div className="row justify-content-center">
                    
                      <div className="col-12 col-xl-6">
                          <QlikObject
                            id="mjNLYGe"
                            height="32px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                          />
                      </div>
                  </div> */}

                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* barchart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 2*/}
                      <QlikCard
                        id="QMcU"
                        height="min(calc(78vh - 263px), calc(320px + 38px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
                  {/* bar chart column */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* bar chart 3*/}
                      <QlikCard
                        id="ktZhgfr"
                        height="min(calc(78vh - 263px - 40px), calc(320px - 4px))"
                        showHeader={true}
                        showMaximize={false}
                        showExport={true}
                        showPdfExport
                        showImageExport={true}
                        exportImageWidth={1280}
                        exportImageHeight={720}
                        onBeforeExportHandler={async ({ vis, exportType }) => {
                          //console.log(data);
                          console.log(vis);
                          if(exportType in { pdf: true, image: true} && vis)
                            await vis.setOptions({ showTitles: true, footnote: `${ExportChartFootnote}` });
                        }}
                        onAfterExportHandler={async ({ vis, exportType }) => {
                          console.log('Export type: ', exportType);
                          if(exportType in { pdf: true, image: true})
                            vis.setOptions({ showTitles: false, footnote:"" });
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>
                  <div className="row justify-content-center">
                      <div className="col-12 col-xl-6">
                          <QlikObject
                            id="NQcVxCk"
                            height="36px"
                            showHeader={false}
                            showMaximize={false}
                            showExport={false}
                          />
                      </div>
                  </div>
                  
               

                </div>

              </div>

            </div>

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  {/* FilterPane */}
                  <QlikCard
                    id="2de5ba8a-cd73-4ed2-be44-c1aa52ef668b"
                    height="min(calc(78vh - 263px + 90px + 8px + 18.8px + 4px), calc(320px + 38px + 90px + 8px + 18.8px + 4px))"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div>

        </div>
        <div className="row justify-content-start">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  {/* pivot table */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="mugL"
                        height="max(calc(100vh - 365px)/2 + 140px, 380px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        onBeforeExportHandler={async ({  }) => {
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                      />
                    </div>
                  </div>

                </div>

              </div>
            </div>
        </div>



          {/* <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="b4231dd2-2ce3-4d63-b394-838d3c6f0b0e"
                height="0px"
                showLoader={false}
              />
            </div>
          </div> */}
          
      </div>
    </section>
  );
}
